import request from '../../utils/request';

export default async id => request(`/ala-agreements/${id}/file`, { responseType: 'blob' })
  .then((blob) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = 'agreement-file';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  });
